import { COUNTRIES } from '@config/constants'

const imgPath = '/img/product/social-proof'

export const SOCIAL_PROOF_IMAGES = {
  [COUNTRIES.FR]: [
    {
      src: `${imgPath}/fr/trustpilot-fr.svg`,
    },
    {
      src: `${imgPath}/fr/adyen-fr.svg`,
    },
    {
      src: `${imgPath}/fr/next40-fr.svg`,
    },
    {
      src: `${imgPath}/fr/fevad-fr.svg`,
    },
  ],
  [COUNTRIES.US]: [
    {
      src: `${imgPath}/us/google-us.svg`,
    },
    {
      src: `${imgPath}/us/trustpilot-us.svg`,
    },
    {
      src: `${imgPath}/us/bbb-us.svg`,
    },
  ],
  [COUNTRIES.ES]: [
    {
      src: `${imgPath}/es/trustedshop-es.svg`,
    },
    {
      src: `${imgPath}/es/confianza-online-es.svg`,
    },
    {
      src: `${imgPath}/es/trust-ecommerce-europe-es.svg`,
    },
    {
      src: `${imgPath}/es/adyen-es.svg`,
    },
  ],
  [COUNTRIES.DE]: [
    {
      src: `${imgPath}/de/trustedshop-de.svg`,
    },
    {
      src: `${imgPath}/de/trustpilot-de.svg`,
    },
    {
      src: `${imgPath}/de/rtl-de.svg`,
    },
    {
      src: `${imgPath}/de/computer-bild-de.svg`,
    },
  ],
}
